/* React base component */
import { Component } from "react"

/* Category to glyph name map */
const MAP = {
    nails: "sparkles", ext: "gem", pedi: "foot", remove: "xcircle", podo: "medcross",
    haircut: "scissors", styling: "wind", braiding: "braid", color: "droplet",
    lashes: "eye", brows: "brow", lami: "layers",
    massage: "flower", face: "smile", spa: "leaf",
    wash: "car", tires: "tire", sto: "wrench", detail: "sparkles", polish: "sun"
}

/* Component CatIcon */
class CatIcon extends Component {

    /* SVG glyph elements by name */
    glyphs = {
        sparkles: <path d="M12 3l1.7 5.2a2 2 0 0 0 1.4 1.4L20.4 11l-5.3 1.4a2 2 0 0 0-1.4 1.4L12 19l-1.7-5.2a2 2 0 0 0-1.4-1.4L3.6 11l5.3-1.4a2 2 0 0 0 1.4-1.4z" />,
        gem: <g><path d="M6 3.5h12l3.5 5.5-9.5 11.5L2.5 9z" /><path d="M2.5 9h19" /><path d="M9 3.5 6.5 9 12 20.5" /><path d="M15 3.5 17.5 9 12 20.5" /></g>,
        foot: <g><path d="M9 3.6C7.3 3.6 6.3 5.4 6.3 8.3c0 1.8.4 3 .4 4.8 0 1.7-1.2 2.4-1.2 3.8 0 1.1.9 1.9 2.1 1.9 1.6 0 2.6-1 2.6-3.1 0-2.2.5-3.5.5-5.7 0-3-1-5.6-1.6-6.4z" /><circle cx="14.5" cy="6.4" r="1" /><circle cx="16.6" cy="9" r="1" /><circle cx="16.6" cy="12" r="1" /><circle cx="15" cy="14.6" r="1" /></g>,
        xcircle: <g><circle cx="12" cy="12" r="9" /><path d="M15 9l-6 6" /><path d="M9 9l6 6" /></g>,
        medcross: <g><circle cx="12" cy="12" r="9" /><path d="M12 8v8" /><path d="M8 12h8" /></g>,
        scissors: <g><circle cx="6" cy="6" r="3" /><circle cx="6" cy="18" r="3" /><path d="M20 4 8.12 15.88" /><path d="M14.47 14.48 20 20" /><path d="M8.12 8.12 12 12" /></g>,
        wind: <g><path d="M3 8h11a2.5 2.5 0 1 0-2.5-2.5" /><path d="M3 12h15a2.5 2.5 0 1 1-2.5 2.5" /><path d="M3 16h9a2.5 2.5 0 1 1-2.5 2.5" /></g>,
        braid: <g><path d="M8 3c0 3.5 8 4 8 9s-8 5.5-8 9" /><path d="M16 3c0 3.5-8 4-8 9s8 5.5 8 9" /></g>,
        droplet: <path d="M12 2.7l5.66 5.66a8 8 0 1 1-11.31 0z" />,
        eye: <g><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="2.6" /></g>,
        brow: <g><path d="M3 13.5c2-3.6 6-5.2 9-5.2s7 1.6 9 5.2" /><path d="M6.6 10.8 5.6 8.2" /><path d="M12 8.4V5.6" /><path d="M17.4 10.8 18.4 8.2" /></g>,
        layers: <g><path d="M12 3 2.5 8 12 13l9.5-5z" /><path d="M2.5 12 12 17l9.5-5" /><path d="M2.5 16 12 21l9.5-5" /></g>,
        flower: <g>{[0, 72, 144, 216, 288].map((a) => <ellipse key={`${a}`} cx="12" cy="7.4" rx="2.9" ry="3.7" transform={`rotate(${a} 12 12)`} />)}<circle cx="12" cy="12" r="2.4" /></g>,
        smile: <g><circle cx="12" cy="12" r="9" /><path d="M8.5 14.5s1.3 1.8 3.5 1.8 3.5-1.8 3.5-1.8" /><path d="M9 9.5v.3" /><path d="M15 9.5v.3" /></g>,
        leaf: <g><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.5 19 2c1 2 2 4.2 2 8 0 5.5-4.8 10-10 10z" /><path d="M2 22c0-3 1.85-5.4 5.08-6" /></g>,
        car: <g><path d="M5 17h14v-3.2a2 2 0 0 0-.15-.76l-1.6-3.78A2 2 0 0 0 15.4 8H8.6a2 2 0 0 0-1.85 1.26l-1.6 3.78A2 2 0 0 0 5 13.8V17z" /><circle cx="8" cy="17.5" r="1.6" /><circle cx="16" cy="17.5" r="1.6" /></g>,
        tire: <g><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="3" /><path d="M12 3v3" /><path d="M12 18v3" /><path d="M3 12h3" /><path d="M18 12h3" /></g>,
        wrench: <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />,
        sun: <g><circle cx="12" cy="12" r="4" /><path d="M12 2v2" /><path d="M12 20v2" /><path d="M4.9 4.9l1.4 1.4" /><path d="M17.7 17.7l1.4 1.4" /><path d="M2 12h2" /><path d="M20 12h2" /><path d="M4.9 19.1l1.4-1.4" /><path d="M17.7 6.3l1.4-1.4" /></g>
    }

    render = () => {
        const size = this.props.size || 30
        const key = MAP[this.props.cat] || "sparkles"
        return (
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                {this.glyphs[key]}
            </svg>
        )
    }
}

/* Export */
export default CatIcon
